var map = {
	"./PeopleHost.jpg": 832,
	"./digitalSlice.jpg": 509,
	"./farConlt.jpg": 330,
	"./gh.png": 374,
	"./huaHouMedia.jpg": 637,
	"./logotitle.jpg": 626,
	"./morningSlice.jpg": 685,
	"./notice.jpg": 239,
	"./pcswiper1.jpg": 399,
	"./pcswiper2.jpg": 440,
	"./pcswiper3.jpg": 541,
	"./peopleHostDraw.jpg": 558,
	"./swiper1.jpg": 873,
	"./swiper2.jpg": 673,
	"./swiper3.jpg": 300,
	"./tongyong.jpg": 512,
	"./xiangTanSlice.jpg": 269,
	"./xiangYaDraw.jpg": 40,
	"./xiangYaMorning.jpg": 212,
	"./zhongNanMedia.jpg": 138,
	"./互动交流平台.jpg": 293,
	"./教育考试平台.jpg": 951,
	"./数字切片库.jpg": 723,
	"./晨读切片库.jpg": 71,
	"./视频融媒体.jpg": 262,
	"./资料文件库.jpg": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;